import { styled } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  svg {
    width: 4rem;
    height: 4rem;
    color: ${({ theme }) => theme.colors.blue03.color};
  }

  button {
    width: 100%;
  }

  .invites {
    margin: 0.4rem 0 1rem;
    color: ${({ theme }) => theme.colors.texts};
    text-decoration: underline;
  }
`;
